module.exports = __webpack_public_path__ + "img/add_desktop_5.d4ea10cd.png";